'use client';
import React from 'react';
import Link from 'next/link';
import PublicHeader from '@/components/PublicHeader';
import PublicFooter from '@/components/PublicFooter';
import Icon from '@/components/ui/AppIcon';

const team = [
{ name: 'Joko Pramono', role: 'CEO & Founder', desc: '15 tahun pengalaman di industri properti Jawa Barat', avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_13ee6b2fe-1787210097472.png" },
{ name: 'Ahmad Ilham S', role: 'Co-Founder & Head of Sales', desc: 'Spesialis kavling premium dengan track record 500+ transaksi', avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_16520fff5-1787210094688.png" },
{ name: 'Ahmad Fauzan', role: 'Head of Legal', desc: 'Notaris berpengalaman, memastikan setiap transaksi aman secara hukum', avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1c9d2ffca-1787210094930.png" }];


const values = [
{ title: 'Transparansi', desc: 'Semua informasi harga, legalitas, dan proses kami sampaikan secara terbuka tanpa ada yang disembunyikan.', icon: 'EyeIcon' },
{ title: 'Integritas', desc: 'Kami hanya menawarkan kavling yang benar-benar tersedia dengan legalitas yang sudah terverifikasi.', icon: 'ShieldCheckIcon' },
{ title: 'Profesionalisme', desc: 'Tim kami terdiri dari profesional berpengalaman yang siap memberikan layanan terbaik.', icon: 'StarIcon' },
{ title: 'Kepercayaan', desc: 'Dibangun di atas kepercayaan lebih dari 500 pembeli yang telah memiliki kavling bersama kami.', icon: 'HeartIcon' }];


export default function TentangKamiPage() {
  return (
    <div className="min-h-screen bg-background">
      <PublicHeader />

      {/* Hero */}
      <section className="bg-gradient-to-br from-primary to-primary-dark py-20">
        <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10 2xl:px-16 text-center">
          <nav className="flex items-center justify-center gap-2 text-sm text-white/60 mb-6">
            <Link href="/homepage" className="hover:text-white">Beranda</Link>
            <Icon name="ChevronRightIcon" size={14} />
            <span className="text-white">Tentang Kami</span>
          </nav>
          <h1 className="text-4xl lg:text-5xl font-bold text-white mb-6">Tentang BETALAND.ID</h1>
          <p className="text-white/70 text-lg max-w-2xl mx-auto">
            Platform properti kavling terpercaya yang menghubungkan calon pembeli dengan kavling impian mereka. Legalitas terjamin, proses transparan.
          </p>
        </div>
      </section>

      {/* About */}
      <section className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10 2xl:px-16 py-16">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <p className="text-sm font-semibold text-accent uppercase tracking-wider mb-3">Profil Perusahaan</p>
            <h2 className="text-3xl font-bold text-foreground mb-5">Membangun Kepercayaan Sejak 2018</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">BETALAND.ID adalah platform properti kavling yang berdiri sejak 2018 di Sragen, Jawa Tengah. Kami hadir untuk menyederhanakan proses pembelian kavling yang selama ini dianggap rumit dan penuh risiko.

            </p>
            <p className="text-muted-foreground leading-relaxed mb-6">
              Dengan pengalaman lebih dari 6 tahun dan lebih dari 500 transaksi yang berhasil, kami telah membuktikan bahwa membeli kavling bisa dilakukan dengan aman, transparan, dan mudah.
            </p>
            <div className="grid grid-cols-2 gap-4">
              {[
              { label: 'Tahun Berdiri', value: '2018' },
              { label: 'Total Transaksi', value: '500+' },
              { label: 'Proyek Aktif', value: '3' },
              { label: 'Partner Agent', value: '200+' }].
              map((s) =>
              <div key={s.label} className="bg-muted rounded-xl p-4">
                  <p className="text-2xl font-bold text-primary">{s.value}</p>
                  <p className="text-sm text-muted-foreground">{s.label}</p>
                </div>
              )}
            </div>
          </div>
          <div className="bg-card rounded-2xl p-8 border border-border shadow-card">
            <h3 className="font-bold text-foreground text-xl mb-4">Visi & Misi</h3>
            <div className="mb-5">
              <p className="font-semibold text-primary mb-2">Visi</p>
              <p className="text-muted-foreground text-sm leading-relaxed">Menjadi platform properti kavling terpercaya dan terbesar di Indonesia yang menghubungkan jutaan calon pembeli dengan kavling impian mereka.</p>
            </div>
            <div>
              <p className="font-semibold text-primary mb-2">Misi</p>
              <ul className="space-y-2">
                {[
                'Menyediakan kavling berkualitas dengan legalitas terjamin',
                'Menyederhanakan proses pembelian kavling',
                'Membangun ekosistem properti yang transparan dan terpercaya',
                'Memberdayakan agent dan partner untuk berkembang bersama'].
                map((m) =>
                <li key={m} className="flex items-start gap-2 text-sm text-muted-foreground">
                    <Icon name="CheckCircleIcon" size={14} className="text-primary mt-0.5 flex-shrink-0" /> {m}
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="bg-muted/50 py-16">
        <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10 2xl:px-16">
          <div className="text-center mb-12">
            <p className="text-sm font-semibold text-accent uppercase tracking-wider mb-2">Nilai Kami</p>
            <h2 className="text-3xl font-bold text-foreground">Prinsip yang Kami Pegang</h2>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {values.map((v) =>
            <div key={v.title} className="bg-card rounded-2xl p-6 border border-border shadow-card text-center">
                <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mx-auto mb-4">
                  <Icon name={v.icon as any} size={24} className="text-primary" />
                </div>
                <h3 className="font-bold text-foreground mb-2">{v.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{v.desc}</p>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10 2xl:px-16 py-16">
        <div className="text-center mb-12">
          <p className="text-sm font-semibold text-accent uppercase tracking-wider mb-2">Tim Kami</p>
          <h2 className="text-3xl font-bold text-foreground">Profesional Berpengalaman</h2>
        </div>
        <div className="grid sm:grid-cols-3 gap-6 max-w-3xl mx-auto">
          {team.map((t) =>
          <div key={t.name} className="bg-card rounded-2xl p-6 border border-border shadow-card text-center">
              <img src={t.avatar} alt={`Foto ${t.name}`} className="w-20 h-20 rounded-full object-cover mx-auto mb-4" />
              <h3 className="font-bold text-foreground">{t.name}</h3>
              <p className="text-sm text-primary font-medium mb-2">{t.role}</p>
              <p className="text-xs text-muted-foreground">{t.desc}</p>
            </div>
          )}
        </div>
      </section>

      {/* Contact */}
      <section className="bg-muted/50 py-16">
        <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10 2xl:px-16">
          <div className="text-center mb-10">
            <h2 className="text-3xl font-bold text-foreground">Hubungi Kami</h2>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 max-w-4xl mx-auto">
            {[
            { icon: 'ChatBubbleLeftRightIcon', label: 'WhatsApp', value: '+62 812-8276-0110', href: 'https://wa.me/6281282760110', color: 'text-[#25D366]' },
            { icon: 'PhoneIcon', label: 'Telepon', value: '+62 812-8276-0110', href: 'tel:+6281282760110', color: 'text-primary' },
            { icon: 'EnvelopeIcon', label: 'Email', value: 'betalandproperty@gmail.com', href: 'mailto:betalandproperty@gmail.com', color: 'text-accent' },
            { icon: 'MapPinIcon', label: 'Kantor', value: 'Sumengko, Sragen Tengah, Kec. Sragen, Kab. Sragen, Jawa Tengah 57211', href: '#', color: 'text-blue' }].
            map((c) =>
            <a key={c.label} href={c.href} target={c.href.startsWith('http') ? '_blank' : undefined} rel="noopener noreferrer"
            className="bg-card rounded-2xl p-5 border border-border shadow-card text-center hover:shadow-card-hover transition-all">
                <Icon name={c.icon as any} size={24} className={`${c.color} mx-auto mb-3`} />
                <p className="font-semibold text-foreground text-sm">{c.label}</p>
                <p className="text-xs text-muted-foreground mt-1">{c.value}</p>
              </a>
            )}
          </div>
          <p className="text-center text-sm text-muted-foreground mt-6">Jam Layanan: Senin–Sabtu, 08.00–17.00 WIB</p>
        </div>
      </section>

      <PublicFooter />
    </div>);

}